import React from "react"
import { Progress } from "reactstrap"
import { useTranslation } from "react-i18next"

const topLocations: {
  location: string
  couponsPerDay: number
  percentage: number
}[] = [
  {
    location: "doha",
    couponsPerDay: 100,
    percentage: 50,
  },
  {
    location: "al khor",
    couponsPerDay: 50,
    percentage: 20,
  },
  {
    location: "al rayyan",
    couponsPerDay: 15,
    percentage: 15,
  },
  {
    location: "al khor",
    couponsPerDay: 10,
    percentage: 5,
  },
  {
    location: "al wakrah",
    couponsPerDay: 5,
    percentage: 3,
  },
  {
    location: "other locations",
    couponsPerDay: 3,
    percentage: 2,
  },
]

export const TopLocations = () => {
  const { i18n } = useTranslation()
  return (
    <div className="container-fluid p-0">
      <h4 className="font-size-16 text-capitalize fw-semibold mb-4">
        {i18n.t("dashboard_topLocation")}
      </h4>
      <div className="d-flex flex-column gap-3">
        {topLocations.map((location, index) => (
          <div
            key={index}
            style={{
              border: "1px solid #30303014",
              boxShadow: "0px 1px 5px 0px #00000026",
            }}
            className="d-flex align-items-center justify-content-start gap-2 p-2 rounded-3"
          >
            <div className="d-flex flex-column align-items-start justify-content-start gap-1 flex-grow-1">
              <p className="m-0 font-size-14 fw-medium text-capitalize lh-1">
                {location.location}
              </p>
              <p
                className="m-0 font-size-14 fw-regular text-capitalize lh-1"
                style={{ color: "#737373" }}
              >
                {location.couponsPerDay} {i18n.t("dashboard_couponPerDay")}
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-start gap-2 flex-grow-1">
              <div className="animated-progress mb-0 w-100">
                <Progress
                  style={{
                    backgroundColor: "#b7cce4",
                    boxShadow: "0px 4px 4px 0px #00000040",
                  }}
                  value={location.percentage}
                  color="primary"
                />
              </div>
              <p className="m-0 font-size-14 fw-medium">
                {location.percentage}%
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
